var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:'base-tag ' + _vm.typeTag + _vm.sizeTag},[_vm._t("default"),_vm._v(" "),(_vm.closeTag)?_c('i',{staticClass:"el-icon-close",on:{"click":function($event){return _vm.handleClose()}}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }